import { Route } from '@tanstack/router'

import { profileRoute } from '..'

export type FreeBonusSearch = {
  activeTab?: number
}

export const freeBonusRoute = new Route({
  getParentRoute: () => profileRoute,
  path: 'free-bonus',
})
